import { BaseEntity } from '../../models';
import { mercadoAtivo } from './situacao';
import { UnidadeNegocio } from '../unidade-negocio';
import { ItemTipo } from '../item-tipo';

export class Mercado implements BaseEntity {
    id: number;
    idEmpresa: number;
    codigo: number;
    nome: string;
    situacao: number;
    idUnidadeNegocio: number;
    unidadeNegocio: UnidadeNegocio;
    idItemTipo: number;
    itemTipo: ItemTipo;

    // Integração ERP
    codigoIntegracaoErp: string;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    constructor() {
        this.situacao = mercadoAtivo.id;
    }
}
